import BadgeDirective from './BadgeDirective';

export default angular.module('edge.platform.widgets.badge', []).directive('gwBadge', BadgeDirective);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/badge/module.js
// module id = 1095
// module chunks = 0